import axios from "./axios";

export default {
    /**
     * Get All Invoices
     * @api {Get} manageinvoice
     */
    getInvoices(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getCashierCut(data) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/cashiercut',
            headers: { 'content-type': 'application/json' },
            params: data
        }

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        console.log( data );
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject( error )
                } );
        } );
    },
    getCashierCutByDates(data, envType) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/cashiercutbydates',
            headers: { 'content-type': 'application/json' },
            params: { ...data, envType },
        }

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data, dataDetallada } = responseResult;
                        resolve( { data, dataDetallada } );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject( error )
                } );
        } );
    },
    getCashierCutFiltered(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/cashiercut/filtered',
            headers: { 'content-type': 'application/json' },
            params: filter
        }

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject( error )
                } );
        } );
    },
    getCashierCutFilteredByDates(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/cashiercut/filteredDates',
            headers: { 'content-type': 'application/json' },
            params: filter
        }

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    const { data: responseResult } = response;

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject( error )
                } );
        } );
    },
    getInvoicesPOSHistory(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/history',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getImportedSalesHistory(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/imported-sales/history',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },
    deleteImportedSaleInvoice(id) {
        const options = {
            method: 'DELETE',
            url: `manageinvoice/imported-sales/${id}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },
    deleteImportedInvoices(invoiceIds) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/deleteImportedInvoices',
            headers: {'content-type': 'application/json'},
            data: {
                invoiceIds
            }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },
    getInvoicesPOSHistoryNotBilled(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/history/notbilled',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getPendingDeliveries(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/pending-deliveries',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getDeliveredProducts(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/delivered-products',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceIsNotBilled(params) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/isnotbilled',
            headers: {'content-type': 'application/json'},
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesFiltering(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/list/filtering',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesFilteringByDates(filterDates) {
        console.log(filterDates);
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/list/filtering/bydates',
            headers: {'content-type': 'application/json'},
            params: {...filterDates}
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesFilteringNotBilled(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/pos/notbilled/filtering',
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoice(id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/${id}`,
            headers: {'content-type': 'application/json'}
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getSalesHistory() {
        const options = {
            method: 'GET',
            url: `manageinvoice/saleshistory`,
            headers: {'content-type': 'application/json'}
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    salesfilterhistory(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/salesfilterhistory`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    salesfilterhistoryColumn(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/salesfilterhistorycolumns`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    salesfilterhistoryBydate(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/salesfilterhistoryBydate`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceProductItems(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/products/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceProductItemsWithStock(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/products2/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceProductItemsWithDeliveryStatus(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/products/delivery/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    markProductAsDelivered(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/products/markDelivered',
            headers: {'content-type': 'application/json'},
            data: data
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    markAllProductsAsDelivered(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/products/markAllDelivered',
            headers: {'content-type': 'application/json'},
            data: data
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceServiceItems(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/services/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    deleteInvoice(id) {
        const options = {
            method: 'DELETE',
            url: `manageinvoice/${id}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    deleteInvoiceWithInventory(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/deleteInvoiceWithInventory`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response)
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response)
                    reject(error)
                })
        })
    },
    addInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    addServiceToClient(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/addservices`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    nullInvoice(id, data) {
        const options = {
            method: 'PUT',
            url: `manageinvoice/nullify/${id}`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoiceID(params) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/invoicenumber',
            // headers: {'content-type': 'application/json'},
            params: params
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
            })
        })
    },
    loadInfoInvoice(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/loadinfoinvoice',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    saveOrUpdateInfoInvoices(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/saveorupdateinvoicescorrelatives',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    invalidInvoice(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/invalidinvoice',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    contingencyProcess(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/contingencyprocess',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    consultBatchProcess(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/consultbatchprocess',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    consultBatchProcess2(data){
        const options = {
            method: 'POST', 
            url: 'manageinvoice/consultbatchprocess2',
            headers: {'content-type': 'application/json'},
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getDteJsonHeaderByInvoice(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/dtejsonheader/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    async getAllInvoiceItems(invoice_id) {
        try {
            const products = await this.getInvoiceProductItems(invoice_id);
            const services = await this.getInvoiceServiceItems(invoice_id);
            return products.concat(services);
        } catch (error) {
            console.log(error)
            throw new Error(error);
        }

        
    },
    async sendInvoiceMail(data) {
        // try {
        const options = {
            timeout: 120000,
            method: 'POST',
            url: `manageinvoice/sendinvoicemail`,
            headers: {'content-type': 'application/json'},
            data
        };
        console.log('entré');
        const result = await axios(options);
        
        const { data: { success, message } } = result;
        if( !success ) {
            // console.log(result);
            throw message;
        }
        return result;
        // } catch (error) {
        //     // console.log('del lado del error', error);
        //     throw error;
        // }
    },
    getDocRelatedByInvoice(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/docrelated/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getDnrRelatedByInvoice(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/dnrrelated/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    
    // Nuevo método unificado para obtener todos los datos de facturas en una sola petición
    getCompleteInvoicesData(invoiceIds) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/complete-invoice-data',
            headers: {'content-type': 'application/json'},
            data: { invoiceIds }
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data?.message || error.message)
                })
        })
    },

    // Nuevo método unificado para obtener todos los datos de una sola factura (1 petición en lugar de 4)
    getCompleteSingleInvoiceData(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/complete-single-invoice/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data?.message || error.message)
                })
        })
    },
    getProductsSalesHistory() {
        const options = {
            method: 'GET',
            url: `manageinvoice/productssaleshistory`,
            headers: {'content-type': 'application/json'}
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    productsSalesFilterHistory(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/productssalesfilterhistory`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    productsSalesFilterHistoryColumn(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/productssalesfilterhistorycolumns`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    productsSalesFilterHistoryByDate(filter) {
        const options = {
            method: 'GET',
            url: `manageinvoice/productssalesfilterhistoryBydate`,
            headers: {'content-type': 'application/json'},
            params: filter
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicePayments(invoice_id) {
        const options = {
            method: 'GET',
            url: `manageinvoice/getInvoicePayments/${invoice_id}`,
            headers: {'content-type': 'application/json'}
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getCashierCutDetails(filter) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/getCashierCutDetails',
            headers: { 'content-type': 'application/json' },
            params: filter
        }

        return new Promise( ( resolve, reject ) => {
            axios( options )
                .then( response => {
                    const { data: responseResult } = response;
                    console.log('DETAILS')
                    console.log(response)

                    const { success } = responseResult;
                    
                    if( success ) {
                        const { data } = responseResult;
                        resolve( data );
                    } else {
                        const { message, status } = responseResult;

                        reject( { status, message } );
                    }
                } )
                .catch( error => {
                    reject(error )
                } );
        } );
    },

    newIdempotencyKey() {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    },

    createInvoice(data, idempotencyKey = null, pos = false) {
        const options = {
            method: 'POST',
            url: pos ? 'manageinvoice/createInvoice/pos' : 'manageinvoice/createInvoice',
            headers: {
                'content-type': 'application/json',
                ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {})
            },
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data)
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            data: error,
                            transportFailure: true
                        })
                    }
                })
        })
    },

    retryDteByInvoice(ID_Invoice, idempotencyKey = null) {
        const options = {
            method: 'POST',
            url: `manageinvoice/invoice/${ID_Invoice}/retry-dte`,
            headers: {
                'content-type': 'application/json',
                ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {})
            },
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data)
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message,
                            transportFailure: true
                        })
                    }
                })
        })
    },

    getInvoiceAttemptStatus(idempotencyKey) {
        return axios.get(`manageinvoice/idempotency/${idempotencyKey}`)
            .then(response => response.data);
    },

    sendTestDteBatch(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/test-dte-batch',
            headers: {'content-type': 'application/json'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data);
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message
                        });
                    }
                })
        });
    },

    getTestDteBatchStatus(jobId) {
        const options = {
            method: 'GET',
            url: `manageinvoice/test-dte-batch/${jobId}`,
            headers: {'content-type': 'application/json'},
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data);
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message
                        });
                    }
                })
        });
    },

    processSeparatedTestDteContingency(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/test-dte-batch/contingency-process',
            headers: {'content-type': 'application/json'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data);
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message
                        });
                    }
                })
        });
    },

    async updateInvoiceCustomer(ID_Invoice) {
        return axios({
            method: 'PUT',
            url: `manageinvoice/invoice/${ID_Invoice}/update-customer`,
            headers: {'content-type': 'application/json'},
        })
    },

    updateInvoiceSelectors(data) {
        const options = {
            method: 'PATCH',
            url: `manageinvoice/invoice/${data.ID_Invoice}/update-selectors`,
            headers: {'content-type': 'application/json'},
            data
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message);
                });
        });
    },

    getOrCreateTempInvoice(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/tmp/getOrCreateTempInvoice',
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    saveHeaderInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/tmp/saveHeaderInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    saveDetailsInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/tmp/saveDetailsInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    deleteDestailsInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/tmp/deleteDestailsInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    countItemsDetailsInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/tmp/countItemsDetailsInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    saveAllDetailsInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/tmp/saveAllDetailsInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    
    // Método para crear facturas de servicios desde importación masiva
    createServiceInvoice(data) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/createServiceInvoice',
            headers: {'content-type': 'multipart/form-data'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        reject(error.response.data)
                    }
                    else {
                        reject({
                            status: 500,
                            success: false,
                            message: error.message || 'Error al crear la factura de servicios'
                        })
                    }
                })
        })
    },

    // Método para verificar facturas duplicadas (respuesta detallada)
    verifyDuplicatedInvoices(invoiceIds) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/verifyDuplicatedInvoices',
            headers: {'content-type': 'application/json'},
            params: { invoiceIds }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },

    // Método para verificar facturas duplicadas (solo devuelve IDs duplicados)
    checkDuplicatedInvoices(invoiceIds) {
        const options = {
            method: 'GET',
            url: 'manageinvoice/checkDuplicatedInvoices',
            headers: {'content-type': 'application/json'},
            params: { invoiceIds }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },

    updateAccountCatalogByItemInvoice(data) {
        const options = {
            method: 'POST',
            url: `manageinvoice/updateAccountCatalogByItemInvoice`,
            headers: {'content-type': 'application/json'},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error.response);
                    reject(error)
                })
        })
    },
    invalidInvoiceDclYCl(data){
        const options = {
            method: 'POST',
            url: 'manageinvoice/invalidInvoiceDclYCl',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    splitInvoiceItems(payload) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/split-invoice-items',
            headers: {'content-type': 'application/json'},
            data: payload
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || error.message)
                })
        })
    },
    updateTemplatePaymentFrequency(invoiceId, data) {
        const options = {
            method: 'PUT',
            url: `manageinvoice/template/payment-frequency/${invoiceId}`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    processSelectedRecurringTemplates(templates) {
        const options = {
            method: 'POST',
            url: 'manageinvoice/templates/process-recurring',
            headers: {'content-type': 'application/json'},
            data: { templates }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
